pageId = 'page-projects-info'
page = "##{ pageId }"

$ ->
  $(document)
  .on 'click', ".simple-dialog .form-project-clone .btn-cancel", (e) ->
    simple.dialog.removeAll()
  .on 'click', "#{ page } .btn-project-clone", (e) ->
    e.preventDefault()

    btn = $(@)
    row = btn.closest('tr')

    tplData =
      action: btn.data('clone-url')
      projectName: row.find('.project-name').text()

    dialog = simple.dialog
      content: $(simple.tpl($('#tpl-project-clone').html(), tplData)),
      width: 620,
      modal: true,
      buttons: null
  .on 'ajax:success', "#{ page } .btn-project-clone", (e, result) ->
    unless result.length
      simple.dialog.message
        content: '你没有其他团队的超级管理员权限，无法完成复制操作'
      return

    html = (simple.tpl('''
      <option value="{{ guid }}">{{ name | encodeHtml }}</option>
    ''', team) for team in result).join('')

    $('.form-project-clone select[name=tguid]').html(html)
      .prop('disabled', false)
  .on 'ajax:success', '.simple-dialog .form-project-clone', (e, result) ->
    return unless result.success

    tpl = '''
      <h3 class="simple-dialog-title">正在复制项目...</h3>
      <p>这个过程通常很快，项目复制完成后会自动打开。如果项目数据量很大，会需要更长的时间。</p>
    '''

    dialog = simple.dialog
      width: 520
      modal: true
      clickModalRemove: false
      showRemoveButton: false
      content: tpl
      buttons: null

    dialog.el.addClass(result.task_guid)
  .on 'ajax:success', '.projects .link-project-unarchive', (e, result) ->
    return if result.success

    simple.dialog.message content: '抱歉，激活失败了，请稍后再试'
  .on 'ajax:success', '.projects .link-project-recover', (e, result) ->
    return if result.success

    simple.dialog.message content: '抱歉，恢复失败了，请稍后再试'
